import React from "react";
import { useFormikContext } from "formik";
import TextInput from "../../../../../components/form/text-input";
import Collapsible from "../../../../../components/collapsible";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";

const FeeDefaults = () => {
  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const { touched, handleBlur, values, errors, handleChange, setFieldValue } =
    useFormikContext();
  const defaultFees = pricingDefaults?.default_fees;

  let modelDefaults = {};
  let defaultFeesDefaults = {};
  Object.entries(pricingDefaults[values.pricing_model]).forEach(([key, value]) => {
    if (key.includes(values.pricing_model)) {
      modelDefaults[key] = value;
    } else {
      defaultFeesDefaults[key] = value;
    }
  });

  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  return (
    <Collapsible title="Other fee defaults" defaultExpanded={true}>
      <div className={styles.body}>
        {defaultFeesDefaults?.setup_fee?.visible && defaultFeesDefaults?.setup_fee?.visible === true && (
          <TextInput
            label={"Setup Fee"}
            placeholder={defaultFeesDefaults?.setup_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"setup_fee"}
            name={"setup_fee"}
            value={values.setup_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.setup_fee}
            errored={errors.setup_fee}
            error={errors.setup_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.setup_fee?.soft_limit,
              values.setup_fee,
              errors.setup_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("setup_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.monthly_access_fee?.visible && defaultFeesDefaults?.monthly_access_fee?.visible === true && (
          <TextInput
            label={"Monthly Access Fee"}
            placeholder={defaultFeesDefaults?.monthly_access_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"monthly_access_fee"}
            name={"monthly_access_fee"}
            value={values.monthly_access_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.monthly_access_fee}
            errored={errors.monthly_access_fee}
            error={errors.monthly_access_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.monthly_access_fee?.soft_limit,
              values.monthly_access_fee,
              errors.monthly_access_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("monthly_access_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.data_breach?.visible && defaultFeesDefaults?.data_breach?.visible === true && (
          <TextInput
            label={"$100K Data Breach"}
            placeholder={defaultFeesDefaults?.data_breach?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"data_breach"}
            name={"data_breach"}
            value={values.data_breach}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.data_breach}
            errored={errors.data_breach}
            error={errors.data_breach}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.data_breach?.soft_limit,
              values.data_breach,
              errors.data_breach,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("data_breach", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.monthly_minimum?.visible && defaultFeesDefaults?.monthly_minimum?.visible === true && (
          <TextInput
            label={"Monthly Minimum"}
            placeholder={defaultFeesDefaults?.monthly_minimum?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"monthly_minimum"}
            name={"monthly_minimum"}
            value={values.monthly_minimum}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.monthly_minimum}
            errored={errors.monthly_minimum}
            error={errors.monthly_minimum}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.monthly_minimum?.soft_limit,
              values.monthly_minimum,
              errors.monthly_minimum,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("monthly_minimum", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.semi_annual_tech_fee?.visible && defaultFeesDefaults?.semi_annual_tech_fee?.visible === true && (
          <TextInput
            label={"Semi-Annual Tech Fee"}
            placeholder={defaultFeesDefaults?.semi_annual_tech_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"semi_annual_tech_fee"}
            name={"semi_annual_tech_fee"}
            value={values.semi_annual_tech_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.semi_annual_tech_fee}
            errored={errors.semi_annual_tech_fee}
            error={errors.semi_annual_tech_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.semi_annual_tech_fee?.soft_limit,
              values.semi_annual_tech_fee,
              errors.semi_annual_tech_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("semi_annual_tech_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.voice_aru?.visible && defaultFeesDefaults?.voice_aru?.visible === true && (
          <TextInput
            label={"Voice ARU"}
            placeholder={defaultFeesDefaults?.voice_aru?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/auth"}
            id={"voice_aru"}
            name={"voice_aru"}
            value={values.voice_aru}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.voice_aru}
            errored={errors.voice_aru}
            error={errors.voice_aru}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.voice_aru?.soft_limit,
              values.voice_aru,
              errors.voice_aru,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("voice_aru", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.batch_fee?.visible && defaultFeesDefaults?.batch_fee?.visible === true && (
          <TextInput
            label={"Batch Fee"}
            placeholder={defaultFeesDefaults?.batch_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"batch_fee"}
            name={"batch_fee"}
            value={values.batch_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.batch_fee}
            errored={errors.batch_fee}
            error={errors.batch_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.batch_fee?.soft_limit,
              values.batch_fee,
              errors.batch_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("batch_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.returned_ach_item?.visible && defaultFeesDefaults?.returned_ach_item?.visible === true && (
          <TextInput
            label={"Returned ACH Item"}
            placeholder={defaultFeesDefaults?.returned_ach_item?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"returned_ach_item"}
            name={"returned_ach_item"}
            value={values.returned_ach_item}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.returned_ach_item}
            errored={errors.returned_ach_item}
            error={errors.returned_ach_item}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.returned_ach_item?.soft_limit,
              values.returned_ach_item,
              errors.returned_ach_item,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("returned_ach_item", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.avs_fee?.visible && defaultFeesDefaults?.avs_fee?.visible === true && (
          <TextInput
            label={"AVS Fee"}
            placeholder={defaultFeesDefaults?.avs_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/txn"}
            id={"avs_fee"}
            name={"avs_fee"}
            value={values.avs_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.avs_fee}
            errored={errors.avs_fee}
            error={errors.avs_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.avs_fee?.soft_limit,
              values.avs_fee,
              errors.avs_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("avs_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.auth_transaction?.visible && defaultFeesDefaults?.auth_transaction?.visible === true && (
          <TextInput
            label={"3rd Party Auth/Txn"}
            placeholder={defaultFeesDefaults?.auth_transaction?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/txn"}
            id={"auth_transaction"}
            name={"auth_transaction"}
            value={values.auth_transaction}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.auth_transaction}
            errored={errors.auth_transaction}
            error={errors.auth_transaction}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.auth_transaction?.soft_limit,
              values.auth_transaction,
              errors.auth_transaction,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("auth_transaction", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.etf_fee?.visible && defaultFeesDefaults?.etf_fee?.visible === true && (
          <TextInput
            label={"ETF Fee"}
            placeholder={defaultFeesDefaults?.etf_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"etf_fee"}
            name={"etf_fee"}
            value={values.etf_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.etf_fee}
            errored={errors.etf_fee}
            error={errors.etf_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.etf_fee?.soft_limit,
              values.etf_fee,
              errors.etf_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("etf_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.chargeback_fee?.visible && defaultFeesDefaults?.chargeback_fee?.visible === true && (
          <TextInput
            label={"Chargeback Fee"}
            placeholder={defaultFeesDefaults?.chargeback_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"chargeback_fee"}
            name={"chargeback_fee"}
            value={values.chargeback_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.chargeback_fee}
            errored={errors.chargeback_fee}
            error={errors.chargeback_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.chargeback_fee?.soft_limit,
              values.chargeback_fee,
              errors.chargeback_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("chargeback_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.representment_fee?.visible && defaultFeesDefaults?.representment_fee?.visible === true && (
          <TextInput
            label={"Representment Fee"}
            placeholder={defaultFeesDefaults?.representment_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"representment_fee"}
            name={"representment_fee"}
            value={values.representment_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.representment_fee}
            errored={errors.representment_fee}
            error={errors.representment_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.representment_fee?.soft_limit,
              values.representment_fee,
              errors.representment_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("representment_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.pre_dispute_fee?.visible && defaultFeesDefaults?.pre_dispute_fee?.visible === true && (
          <TextInput
            label={"Pre-Dispute Fee"}
            placeholder={defaultFeesDefaults?.pre_dispute_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"pre_dispute_fee"}
            name={"pre_dispute_fee"}
            value={values.pre_dispute_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.pre_dispute_fee}
            errored={errors.pre_dispute_fee}
            error={errors.pre_dispute_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.pre_dispute_fee?.soft_limit,
              values.pre_dispute_fee,
              errors.pre_dispute_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("pre_dispute_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.card_brand_fee?.visible && defaultFeesDefaults?.card_brand_fee?.visible === true && (
          <TextInput
            label={"Card Brand Fee"}
            placeholder={defaultFeesDefaults?.card_brand_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"card_brand_fee"}
            name={"card_brand_fee"}
            value={values.card_brand_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.card_brand_fee}
            errored={errors.card_brand_fee}
            error={errors.card_brand_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.card_brand_fee?.soft_limit,
              values.card_brand_fee,
              errors.card_brand_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("card_brand_fee", e.target.rawValue);
              },
            }}
          />
        )}


        {defaultFeesDefaults?.pci_non_compliance_fee?.visible && defaultFeesDefaults?.pci_non_compliance_fee?.visible === true && (
          <TextInput
            label={"PCI Non-Compliance Fee"}
            placeholder={defaultFeesDefaults?.pci_non_compliance_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"pci_non_compliance_fee"}
            name={"pci_non_compliance_fee"}
            value={values.pci_non_compliance_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.pci_non_compliance_fee}
            errored={errors.pci_non_compliance_fee}
            error={errors.pci_non_compliance_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.pci_non_compliance_fee?.soft_limit,
              values.pci_non_compliance_fee,
              errors.pci_non_compliance_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("pci_non_compliance_fee", e.target.rawValue);
              },
            }}
          />
        )}

        {defaultFeesDefaults?.retrieval_fee?.visible && defaultFeesDefaults?.retrieval_fee?.visible === true && (
          <TextInput
            label={"Retrieval Fee"}
            placeholder={defaultFeesDefaults?.retrieval_fee?.default || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"retrieval_fee"}
            name={"retrieval_fee"}
            value={values.retrieval_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.retrieval_fee}
            errored={errors.retrieval_fee}
            error={errors.retrieval_fee}
            hasWarning={getSoftLimitWarning(
              defaultFeesDefaults?.retrieval_fee?.soft_limit,
              values.retrieval_fee,
              errors.retrieval_fee,
            )}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("retrieval_fee", e.target.rawValue);
              },
            }}
          />
        )}

      </div>
    </Collapsible>
  );
};

export default FeeDefaults;
